<template>
  <div>
    <div
        v-for="(item, index) in orderList"
        :key="index"
        class="goods-container"
    >
      <div class="tui-goods-item">
        <!-- <img :src="item.orderProductResponse.url" class="tui-goods-img" v-if="item.orderProductResponse.url&&item.orderProductResponse.url!=null&&item.orderProductResponse.url!=''"/>
            <img class="tworowimg" src="../assets/images/LOGO.png" v-else/> -->
        <van-image :src="item.orderProductResponse.url" class="tui-goods-img">
          <template v-slot:error>
            <img class="tworowimg" src="../assets/images/LOGO.png"/>
          </template>
        </van-image>

        <div class="tui-goods-center">
          <div>
            <div class="tui-goods-top">
              <div class="tui-goods-name">
                {{ item.orderProductResponse.name }}
              </div>
              <div class="order-operation">
                <span v-if="item.status == 1">待支付</span>
                <span v-if="item.status == 2">已取消</span>
                <span v-if="item.status == 3">已关闭</span>
                <!-- <span v-if="item.status == 4">待审核</span>
                            <span v-if="item.status == 5">审核拒绝</span> -->
                <!-- <span v-if="item.status == 6">已冻结</span> -->
                <span
                    v-if="
                    item.status == 7 ||
                    item.status == 4 ||
                    item.status == 5 ||
                    item.status == 6
                  "
                >待发货</span
                >
                <span v-if="item.status == 8">已发货</span>
                <span v-if="item.status == 9">已签收</span>
                <span v-if="item.status == 10">已完成</span>
                <span v-if="item.status == 11">已结算</span>
                <span v-if="item.status == 12">待冲账</span>
                <!-- <span @click="routeToDetails(item)">订单详情</span> -->
              </div>
            </div>
            <div class="tui-goods-attr">
              <p>规格：{{ item.skuName }}</p>
              <!-- <p>支持7天无理由退货</p> -->
            </div>
          </div>
          <div class="tui-goods">
            <div class="tui-price-right">
              {{ item.orderProductResponse.point }}积分
            </div>
            <p class="tui-num-right">x{{ item.amount }}</p>
          </div>
        </div>
      </div>
      <div style="margin-left:20px">
        <div v-if="item.reasonType!=''&&item.reasonType!=null">抱歉，当前订单因{{ item.reasonType }}，将延迟发出</div>
        <div v-if="item.reasonType==null&&item.isBooking==1">预售产品，下单后{{ item.bookingDeliverDay }}日发货</div>
      </div>
      <div class="tui-all">
        <!-- <div class="order" v-if="item.status == 4" @click="examine(item)">
                审核资料
            </div> -->
        <div
            style="border: 1px #666 solid"
            @click="expedite(item.orderNo)"
            v-if="
            logF(
              item.status,
              item.orderCreate,
              item.isBooking,
              item.bookingDeliverDay
            )
          "
            class="logistics"
        >
          催发货
        </div>
         <div
            style="border: 1px #666 solid"
            @click="
            routeToEquity(
              item.orderNo
            )
          "
            v-if="logS(item.status, item.signTime) && item.orderProductResponse.productType == '2'"
            class="logistics"
        >
          查看权益
        </div>
        <div
            style="border: 1px #666 solid"
            @click="
            routeToLogistics(
              item.logisticsNo,
              item.consigneePhone,
              item.orderNo
            )
          "
            v-if="logS(item.status, item.signTime) && item.orderProductResponse.productType == '1'"
            class="logistics"
        >
          查看物流
        </div>
        <div
            style="border: 1px #2283e2 solid"
            class="gopay"
            @click="openPayDialog(item)"
            v-if="item.status == 1"
        >
          去支付
        </div>
        <div
            class="order"
            style="border: 1px #666 solid"
            @click="detailClick(item)"
        >
          订单详情
        </div>
        <div
            class="order"
            style="border: 1px #666 solid"
            @click="deleteOrder(item)"
            v-if="item.status == 2 || item.status == 3"
        >
          删除订单
        </div>
        <div
            style="border: 1px #f5a623 solid"
            v-if="item.status == 9 && item.isComment == 0"
            class="evaluate"
            @click="toComment(item)"
        >
          待评价
        </div>
        <div
            class="evaluate"
            style="border: 1px #f5a623 solid"
            @click="toReturn(item)"
            v-if="returnS(item.deliveryDate, item.status, item.isOrderReturn)"
        >
          售后
        </div>
        <div
            class="receive"
            style="border: 1px #666 solid"
            @click="toReceived(item)"
            v-if="receivedS(item.orderCreate, item.status, item.isMod)"
        >
          修改收货信息
        </div>
        <!-- <span v-if="item.status == 9 && item.isComment == 1" class="evaluate">已评价</span> -->
        <span
            style="border: 1px #f5a623 solid"
            v-if="item.isComment == 1"
            class="evaluate"
        >已评价</span
        >

        <div
            style="border: 1px #2283e2 solid"
            v-if="item.status == 8"
            class="receiving"
            @click="openTakeOverDialog(item)"
        >
          确认收货
        </div>
      </div>
    </div>
    <!-- 确认收货 -->
    <van-dialog v-model="show" @confirm="confirmTakeOver()" show-cancel-button>
      <div class="tui-receiving">确认收货吗？</div>
    </van-dialog>

    <!-- 支付 -->
    <van-dialog v-model="payfor" @confirm="goPay()" show-cancel-button>
      <div class="tui-receiving">确认支付吗？</div>
      <van-count-down
          class="tui-time"
          :time="time"
          format="DD 天 HH 时 mm 分 ss 秒"
      />
    </van-dialog>
    <van-popup
        v-model="popupArea"
        position="bottom"
        round
        :style="{ height: '50%' }"
    >
      <div class="total">
        <van-icon name="success" size="40" color="#fff" class="icon"/>
        <div class="areatip1">催促发货成功</div>
        <div class="areatip2">已催促仓库尽快为您发货</div>

        <div class="areaconfirm">
          <van-button
              round
              block
              color="var(--theme-color-main)"
              type="primary"
              @click="popupArea = false"
          >我知道了
          </van-button
          >
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  confirmReceipt,
  haierOrderPay,
  selHaierOrderOverdue,
  deleteOrderByOrderNo,
  mOrderExpeditingSaveOrUpdate,
} from '@/api/api';

export default {
  props: {
    orderList: {
      type: Array,
      default: null,
    },
    isButton: {
      type: Boolean,
      default: false,
    },
    // 订单状态
    orderStatus: {
      type: Number,
      default: null,
    },
    subOrderInfo: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      time: '',
      tempItem: null,
      show: false,
      payfor: false,
      orderNo: '',
      parentOrderNo: '',
      payTotalAmount: '',
      tempItems: null,
      popupArea: false,
    };
  },
  methods: {
    examine(item) {
      this.$router.push({
        path: '/orders/toexamine',
        query: {
          orderNo: item.orderNo,
          parentOrderNo: item.parentOrderNo,
        },
      });
    },
    logS(status, signtime) {
      if (status >= 8 && signtime != null) {
        if (status == 10 && signtime !== null && (new Date() - new Date(signtime.replace(/-/g, '/'))) / (1000 * 60 * 60 * 24) > 150) {
          return false;
        } else {
          return true;
        }
      } else {
        if (status < 8) {
          return false;
        } else {
          return true;
        }
      }
    },
    logF(status, orderCreate, isBooking, day) {
      if (status == 7) {
        if (isBooking == 0) {
          if (orderCreate !== null && (new Date() - new Date(orderCreate.replace(/-/g, '/'))) / (1000 * 60 * 60 * 24) >= 3) {
            return true;
          } else {
            return false;
          }
        } else {
          if (orderCreate !== null && (new Date() - new Date(orderCreate.replace(/-/g, '/'))) / (1000 * 60 * 60 * 24) >= day) {
            return true;
          } else {
            return false;
          }
        }
      } else {
        return false;
      }
    },
    returnS(deliveryDate, status, isOrderReturn) {
      console.log(deliveryDate, '2222222222222222');
      // 9:已签收 10:已完成  8:已发货
      if (status > 7) {
        if (deliveryDate) {
          if ((new Date() - new Date(deliveryDate.replace(/-/g, '/'))) / (1000 * 60 * 60 * 24) > 30) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    receivedS(orderCreate, status, ismod) {
      if (orderCreate) {
        var date = new Date(orderCreate.replace(/-/g, '/'));
        date.setDate(new Date(orderCreate.replace(/-/g, '/')).getDate() + 1);
        date.setHours(10);
        date.setMinutes(0);
        date.setSeconds(0);
        //8 已发货
        if (status == 7 || status == 4 || status == 5 || status == 6) {
          if (new Date() < date && ismod == '0') {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
        /*if (status==8) {
          return true
        }else{
          return false
        }*/
      }
    },
    async goPay() {
      let params = {
        buyerId: this.$cookies.get('memberId') || sessionStorage.getItem('memberId'),
        payTotalAmount: this.tempItems.payCredits,
        parentOrderNo: this.tempItems.orderNo,
        phone: this.$cookies.get('memberPhone') || sessionStorage.getItem('memberPhone'),
      };

      let res = await haierOrderPay(params);
      if (res.code === '0000') {
        this.$toast('支付成功');
        this.$emit('deliver');
      } else {
        this.$toast(res.msg);
      }
    },
    // 删除订单
    async deleteOrder(item) {
      let params = {
        orderNo: item.orderNo,
      };

      let res = await deleteOrderByOrderNo(params);
      if (res.code === '0000') {
        this.$toast('删除成功');
        location.reload();
      } else {
        this.$toast(res.error);
      }
    },
    toComment(item) {
      this.$router.push({
        path: '/orders/evaluatingCommodities',
        query: {
          productId: item.productId,
          productCode: item.productCode,
          orderNo: item.orderNo,
          name: item.orderProductResponse.name,
          all: item.orderProductResponse,
        },
      });
    },
    // 退换货
    toReturn(item) {
      this.$router.push({
        path: '/exchange',
        query: {
          orderNo: item.orderNo,
        },
      });
    },
    // 修改收货信息
    toReceived(item) {
      this.$router.push({
        path: '/orders/editReceived',
        query: {
          id: item.id,
          productId: item.productId,
          orderNo: item.orderNo,
          //将内容传递到编辑地址页面
          name: item.receiverName, //获取收货人姓名
          phone: item.consigneePhone, //获取收货人手机号
          city: item.receiverArea, //用于显示的省市区
          address: item.receiverAddress, //用于显示的详细地址
          region: item.receiverCode,
        },
      });
    },
    detailClick(item) {
      this.$router.push({
        path: '/orderDetails',
        query: {
          details: {
            orderNo: item.orderNo,
            receiver: item.receiver,
            receiverName: item.receiverName,
            mark: item.mark,
            orderCreate: item.orderCreate,
            status: item.status,
            name: item.orderProductResponse.name,
            url: item.orderProductResponse.url,
            subtitle: item.orderProductResponse.subtitle,
            totalPoint: item.payCredits,
            amount: item.amount,
            all: item,
          },
        },
      });
    },
    async openPayDialog(item) {
      this.tempItems = item;
      this.payfor = true;
      let params = {
        orderNo: item.orderNo,
      };

      let res = await selHaierOrderOverdue(params);
      if (res.code == '0000') {
        this.time = new Date(res.data.replace(/-/g, '/')) - new Date().getTime();
      }
    },
    openTakeOverDialog(item) {
      this.show = true;
      this.tempItem = item;
    },
    async confirmTakeOver() {
      let params = {
        buyerId: this.$cookies.get('memberId') || sessionStorage.getItem('memberId'),
        orderNo: this.tempItem.orderNo,
      };

      const res = await confirmReceipt(params);
      if (res.code == '0000') {
        this.$toast('已确认收货！');
        this.$emit('getOrderList');
      } else {
        this.$toast(res.msg);
      }
    },
    // 查看权益
    routeToEquity(orderno){
      this.$router.push({
        path: '/orders/equity',
        query: {
          orderNo: orderno,
        },
      });
    },
    // 查看物流
    routeToLogistics(logisticsNo, consigneePhone, orderno) {
      this.$router.push({
        path: '/orders/logistics',
        query: {
          // logisticsNo: logisticsNo+":"+consigneePhone.substr(-4),
          logisticsNo: logisticsNo,
          orderno: orderno,
          // logisticsNo: "780098068058"
        },
      });
    },
    async expedite(orderNo) {
      const res = await mOrderExpeditingSaveOrUpdate({ orderNo: orderNo });
      if (res.code == '0000') {
        this.popupArea = true;
      } else {
        this.$toast(res.msg);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tui-receiving {
  text-align: center;
  padding: 60px;
}

.tui-time {
  text-align: center;
  padding-bottom: 50px;
}

.receiving {
  width: 130px;
  height: 45px;
  line-height: 45px;
  border: 1px $theme-color-main solid;
  color: $theme-color-main;
  border-radius: 20px;
  text-align: center;
  margin-right: 20px;
}

.evaluate {
  width: 130px;
  height: 45px;
  line-height: 45px;
  border: 1px #f5a623 solid;
  color: #f5a623;
  border-radius: 20px;
  text-align: center;
  margin-right: 20px;
}

.order {
  width: 130px;
  height: 45px;
  line-height: 45px;
  border: 1px #666 solid;
  border-radius: 20px;
  text-align: center;
  margin-right: 20px;
}

.receive {
  width: 160px;
  height: 45px;
  line-height: 45px;
  border: 1px #666 solid;
  border-radius: 20px;
  text-align: center;
  margin-right: 20px;
}

.gopay {
  margin-right: 20px;

  width: 130px;
  height: 45px;
  line-height: 45px;
  background: $theme-color-main;
  color: white;
  border: 1px $theme-color-main solid;
  border-radius: 20px;
  text-align: center;
}

.tui-all {
  padding-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.logistics {
  margin-right: 20px;

  width: 130px;
  height: 45px;
  line-height: 45px;
  border: 1px #666 solid;
  border-radius: 20px;
  text-align: center;
}

.tui-goods-item {
  width: 100%;
  padding: 30px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  // border-bottom: 1px solid #efefef;
}

.tui-goods-img {
  width: 180px;
  height: 180px;
  display: block;
  flex-shrink: 0;
  border-radius: 10px;
}

.tui-goods-center {
  flex: 1;
  padding-left: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
}

.tui-goods {
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
}

.tui-goods-top {
  display: flex;
  justify-content: space-between;
}

.tui-goods-name {
  max-width: 80%;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-size: 28px;
  /* line-height: 32px; */
}

.tui-goods-attr {
  max-width: 90%;
  font-size: 26px;
  color: #999999;
  padding-top: 10px;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  display: flex;
  justify-content: space-between;
}

.tui-price-right {
  color: #999999;
}

.tui-num-right {
  text-align: right;
  font-size: 24px;
  color: #888888;
}

.tui-color-red {
  color: #e41f19;
  padding-right: 30px;
}

.tui-goods-price {
  display: flex;
  justify-content: space-between;
  font-size: 24px;
  padding: 20px 30px;
}

.tui-size-24 {
  font-size: 24px;
  line-height: 24px;
}

.tui-order-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background: #fff;
  padding: 10px 30px 20px;
  box-sizing: border-box;
}

.tui-btn-ml {
  margin-left: 20px;
}

.tui-shouhou {
  border-top: 1px solid #efefef;
}

.goods-container {
  border-top: 1px solid #efefef;
  padding-bottom: 30px;
  margin-top: 2px;
  background-color: #fff;
}

.tworowimg {
  width: 100%;
}

.total {
  text-align: center;
  margin-top: 15%;

  .icon {
    background-color: $theme-color-main;
    border-radius: 50%;
    padding: 20px;
  }

  .areatip1 {
    margin-top: 40px;
    font-size: 38px;
    font-weight: bold
  }

  .areatip2 {
    margin: 40px 0;
    font-size: 26px;
  }

  .areaconfirm {
    width: 40%;
    margin-left: 30%;
    margin-top: 18%;
  }
}
</style>
